// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditProfile_wrapper__bnVim","title":"EditProfile_title__3aSaq","formWrapper":"EditProfile_formWrapper__3Aj3A"};